// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__CHXZo","row":"ProcedureTreatmentSummary_row__160sF"};